module.exports = __webpack_public_path__ + "img/graph-01.936b9b34.png";